import React from 'react'

import { FormBuilder, Spinner } from '@acorns/web-components'

import Button from 'components/Button'
import FormContainer from 'components/FormContainer'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { shouldGrayOutCTACall } from 'utils/shouldGrayOutCTA'

import { enhance } from './enhance'
import { getRows, validate } from './form'
import { EnhancedSpendContactInfoProps } from './types'

const NextButton = withClickTrack<any, any>(TRACKER_IDS.CONTACT_INFO.NEXT_BUTTON)(Button)

const SpendContactInfo: React.SFC<EnhancedSpendContactInfoProps> = props => {
  const shouldGrayOutCTA = shouldGrayOutCTACall({
    values: props.values,
    validation: values => validate(values, { forGrayOutCTACheck: true, ...props }),
    ignoredKeys: ['address1', 'address2', 'phoneNumber', 'alsoResidentialAddress'],
  })

  return (
    <>
      <Nav />
      <Layout header={props.header} text={props.text}>
        <FormContainer>
          <FormBuilder
            errors={props.errors}
            handleChange={props.handleChangeIntercept}
            handleSelectChange={props.handleSelectIntercept}
            rows={getRows(props.addressType, props.validateForm, props.fromSpendConfirmation)}
            values={props.values}
            setFieldValue={props.setFieldValue}
          />
        </FormContainer>

        <Separator />
        <NextButton
          styleType={!props.isValid || shouldGrayOutCTA ? 'invalid' : undefined}
          onPress={props.handleSubmitIntercept}
          disabled={props.isSubmitting}
          buttonType={'submit'}
        >
          {props.isSubmitting ? <Spinner height={20} width={20} white={true} /> : 'Next'}
        </NextButton>
      </Layout>
    </>
  )
}

export default enhance(SpendContactInfo)
